import { render, staticRenderFns } from "./StudyPlanTrail.vue?vue&type=template&id=35f0ff6e&scoped=true"
import script from "./StudyPlanTrail.vue?vue&type=script&lang=js"
export * from "./StudyPlanTrail.vue?vue&type=script&lang=js"
import style0 from "./StudyPlanTrail.vue?vue&type=style&index=0&id=35f0ff6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f0ff6e",
  null
  
)

export default component.exports